import themes from './themes'
import setup from './setup'
import assets from './assets'

export default {
  themes,
  setup,
  assets,
}
